import faker from 'faker'
import { http, HttpResponse } from 'msw'

import type { ApiError } from '@webapp/core/interfaces/api/ApiError'
import { type CreateRequestPayload } from '@webapp/modules/spending-cards/data-access/types/CreateRequestPayload'
import { getResponseObject } from '@webapp/tests/getResponseObject'

// Shallow-compares the request body against the expected payload; array
// params are compared element-wise. Extracted from the resolver to keep it
// flat (matches the original inline matcher's behavior exactly).
const payloadMatchesBody = (
  expected: CreateRequestPayload,
  body: any
): boolean => {
  for (const param in expected) {
    if (Array.isArray(expected[param])) {
      for (const item of expected[param]) {
        if (body[param][item] !== expected[param][item]) {
          return false
        }
      }
    } else if (body[param] !== expected[param]) {
      return false
    }
  }

  return true
}

export const mockCreateRequestSuccess = ({
  payload,
  response = { id: faker.random.number(), uuid: faker.random.uuid() },
}: {
  payload?: CreateRequestPayload
  response?: { id: number; uuid: uuid }
} = {}) => {
  return http.post(
    `/api/v4/pay/requests/`,
    async ({ request }) => {
      if (payload) {
        // Read the request body once — in msw v2 the body stream can only be
        // consumed a single time.
        const body = await request.json()
        if (!payloadMatchesBody(payload, body)) {
          return new HttpResponse(null, { status: 400 })
        }
      }

      return HttpResponse.json(getResponseObject(response), { status: 201 })
    },
    { once: true }
  )
}

export const mockCreateRequestError = (
  errResponse: Nullable<Partial<ApiError>> = null
) => {
  return http.post(
    `/api/v4/pay/requests/`,
    () => {
      return HttpResponse.json(errResponse, { status: 400 })
    },
    { once: true }
  )
}
